import { render, staticRenderFns } from "./EditorDetail.vue?vue&type=template&id=07ecbd76&"
import script from "./EditorDetail.vue?vue&type=script&lang=js&"
export * from "./EditorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports